import { ArticleWithRelations } from '@/models/request';

export const getWorkshopsWithClientCommunication = (articles: ArticleWithRelations[]) =>
  [
    ...new Set(
      articles
        .filter(
          (article) => article.workshopOrganization?.workshopConfig?.clientCommunication?.enabled
        )
        .map((article) => article.workshopId)
    ),
  ].map((id) => ({
    entityId: id,
  }));
